'use strict';

define(['app'], function (app) {

  var productPrice = function productPrice() {
    var component = {};

    var _config = {
      selectors: {
        component: '[data-component=productPrice]',
        rrp: '[data-product-price=rrp]',
        price: '[data-product-price=price]',
        saving: '[data-product-price=saving]',
        schemaPrice: '[data-schema=price]',
        recurringPayment: '[data-product-price=recurringPayment]',
        fromPrice: '[data-product-price="fromPrice"]',
        professionalPricingBanner: '[data-product-price=professionalPricingBanner]',
        optionTerm: '[data-product-price=paymentOptionTerm]',
        monthSingular: '[data-product-price=optionMonthTextSingular]',
        monthPlural: '[data-product-price=optionMonthTextPlural]',
        recurringPaymentText: '[data-product-price=recurringPaymentText]',
        fastTrackSwitch: '.fastTrack_onProductPage',
        OTPMessage: '.productPrice_subscribeAndSave_oneTimePurchase_message',
        subscribeMessage: '.productPrice_subscribeAndSave_subscribe_message'
      },
      subscribeChannels: {
        price: 'productPrice/newPrice',
        subscribeAndSaveMessage: 'productPrice/changeSubscribeAndSaveMessage',
        subscribeAndSavePriceChange: 'subscribeAndSave/productPriceChange'
      },
      attributes: {
        subscribeAndSave: 'data-subscribe-and-save'
      }
    };

    var _init = function _init(element, userDriven) {
      component.element = element;

      if (!userDriven) {
        component.subscribeToChannels();
      } else {
        app.publish(component.config.subscribeChannels.subscribeAndSavePriceChange);
      }

      return component;
    };

    var _getNewPrice = function _getNewPrice(productId) {
      var fastTrack = document.querySelector(component.config.selectors.fastTrackSwitch);
      var url = '/' + productId + '.price';
      var queryParams = [];

      if (fastTrack) {
        queryParams.push('useCookieForFastTrackFiltration=' + fastTrack.getAttribute('data-switch-enabled'));
      }

      var enableSubscribeAndSave = component.element.getAttribute(component.config.attributes.subscribeAndSave);
      if (enableSubscribeAndSave) {
        queryParams.push('enableSubscribeAndSave=' + enableSubscribeAndSave);
      }

      var queryString = queryParams.join('&');
      if (queryString) {
        url += '?' + queryString;
      }

      app.ajax.get({
        url: url,
        success: component.successHandler,
        error: component.errorHandler
      });
    };

    var _successHandler = function _successHandler(response) {
      var parent = component.element.parentNode;
      parent.innerHTML = response;
      var element = parent.querySelector('[data-component=productPrice]');
      component.init(element, true);
    };

    var _errorHandler = function _errorHandler() {
      console.error('ERROR: Could not retrieve new price options');
    };

    var _changeSubscribeAndSaveMessage = function _changeSubscribeAndSaveMessage(showOTPMessage, showSubscribeMessage) {
      var OTPMessage = component.element.querySelector(component.config.selectors.OTPMessage);
      var subscribeMessage = component.element.querySelector(component.config.selectors.subscribeMessage);

      if (showOTPMessage) {
        OTPMessage.setAttribute("data-visible", "true");
        subscribeMessage.setAttribute("data-visible", "false");
      }

      if (showSubscribeMessage) {
        OTPMessage.setAttribute("data-visible", "false");
        subscribeMessage.setAttribute("data-visible", "true");
      }
    };

    var _subscribeToChannels = function _subscribeToChannels() {
      app.subscribe(component.config.subscribeChannels.price, component.getNewPrice);
      app.subscribe(component.config.subscribeChannels.subscribeAndSaveMessage, component.changeSubscribeAndSaveMessage);
    };

    component.init = _init;
    component.config = _config;
    component.getNewPrice = _getNewPrice;
    component.successHandler = _successHandler;
    component.errorHandler = _errorHandler;
    component.changeSubscribeAndSaveMessage = _changeSubscribeAndSaveMessage;
    component.subscribeToChannels = _subscribeToChannels;

    return component;
  };

  return productPrice;
});
//# sourceMappingURL=productPrice.js.map
